import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@emi/shared/state/auth';
import { ResultsPageComponent } from '@emi/sku-search/feature/results-page';
import { HomeComponent as SkuSearchHomeComponent } from '@emi/sku-search/feature/home';
import { SkuTimeSeriesComponent } from '@emi/sku-search/feature/sku-time-series';
import { AppComponent } from './app.component';
import { SuccessComponent } from '@emi/shared/feature/success';
import { SkuCapsuleComponent } from '@emi/sku-capsule/feature/sku-capsule';
import { PageNotFoundComponent } from '@emi/shared/ui';
import { LogoutComponent } from '@emi/shared/feature/logout';
import { AboutEuromonitorComponent } from '@emi/shared/feature/about-euromonitor';
import { ConfigureDataComponent } from '@emi/shared/feature/configure-data';
import {
    ContactUsComponent,
    DefinitionsComponent,
    FaqComponent,
    GetStartedComponent,
    MethodologyComponent,
    VideoTutorialsComponent,
    BrowserSupportComponent,
} from '@emi/shared/help-resources';
import * as Constants from '@emi/shared/constants';
import { ExportRouteComponent } from './export-route/export-route.component';
import { SaveAndExtractComponent } from '@emi/shared/feature/save-and-extract';
import { ConfigureDataCanDeactivateGuard, SaveAndExtractCanDeactivateGuard } from '@emi/shared/data-access';
//import { InsightsInfographicsComponent } from '@emi/shared/infographics';

@NgModule({
    imports: [
        RouterModule.forRoot(
            [
                { path: '', redirectTo: Constants.Routes.SKU_SEARCH, pathMatch: 'full' },
                { path: 'protected', component: ResultsPageComponent, canActivate: [AuthGuard] },
                { path: 'unauthorized', component: AppComponent },
                { path: 'callback', component: AppComponent },
                { path: Constants.Routes.LOGOUT_ROUTE, component: LogoutComponent },
                { path: Constants.Routes.ABOUT_EUROMONITOR, component: AboutEuromonitorComponent },
                { path: Constants.Routes.BROWSER_SUPPORT, component: BrowserSupportComponent },
                { path: Constants.Routes.CONTACT_US, component: ContactUsComponent },
                { path: Constants.Routes.GET_STARTED, component: GetStartedComponent },
                { path: Constants.Routes.VIDEO_TUTORIALS, component: VideoTutorialsComponent },
                { path: Constants.Routes.FAQ, component: FaqComponent },
                { path: Constants.Routes.DEFINITIONS, component: DefinitionsComponent },
                { path: Constants.Routes.METHODOLOGY, component: MethodologyComponent },
                // { path: Constants.Routes.INSIGHTS_INFO_GRAPHIC, component: InsightsInfographicsComponent },
                { path: Constants.Routes.SKU_SEARCH, component: SkuSearchHomeComponent },
                { path: Constants.Routes.SKU_SEARCH_RESULTS, component: ResultsPageComponent },
                { path: Constants.Routes.SKU_SEARCH_SKU, component: SkuCapsuleComponent },
                {
                    path: Constants.Routes.SKU_SEARCH_CONFIGURE_DATA_ROUTE,
                    component: ConfigureDataComponent,
                    canDeactivate: [ConfigureDataCanDeactivateGuard]
                },
                { path: Constants.Routes.SKU_SEARCH_PRICE_HISTORY, component: SkuTimeSeriesComponent },
                { path: Constants.Routes.EXPORT_ROUTE, component: ExportRouteComponent },
                { path: Constants.Routes.PAGE_NOT_FOUND_ROUTE, component: PageNotFoundComponent },
                {
                    path: Constants.Routes.SKU_SEARCH_SAVE_AND_EXTRACT_ROUTE,
                    component: SaveAndExtractComponent,
                    canDeactivate: [SaveAndExtractCanDeactivateGuard]
                },
                { path: Constants.Routes.SUCCESS_ROUTE, component: SuccessComponent },
                { path: '**', redirectTo: Constants.Routes.PAGE_NOT_FOUND_ROUTE },
            ],
            {
                useHash: true,
            }
        ),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
